export default function buildFilterParams  (params)  {
    const filters = [
        `filters[is_free]=${params?.free || ''}`,
        `filters[has_color]=${params?.selectedColorId || ''}`,
        `filters[has_space]=${params?.selectedSpaceId || ''}`,
        `q=${params?.searchInputContent || ''}`
    ];
    return filters.filter(Boolean).join('&');
};
